import PropTypes from 'prop-types';
import React from 'react';

import AddressRecord from '../../records/customer/Address';


function CustomerAddress ({ className, address, includeContactName }) {
    return (
        <address className={ className }>
            { address.asList(includeContactName).map(
                (line, key) => <span key={ key }>{ line }<br /></span>
            ) }
        </address>
    );
}


CustomerAddress.propTypes = {
    address: PropTypes.instanceOf(AddressRecord).isRequired,
    className: PropTypes.string,
    includeContactName: PropTypes.bool
};

CustomerAddress.defaultProps = {
    includeContactName: true
};

export default CustomerAddress;
